import LearningProgramJourney from "./LearningProgramJourney";

export default LearningProgramJourney;
